import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer';
import { API_BASE } from '../../utils/api';

// Section Imports
import PriceTrendsHeader from './sections/PriceTrendsHeader';
import PropertySupply from './sections/PropertySupply';
import PropertyDemand from './sections/PropertyDemand';
import LocalProjects from './sections/LocalProjects';

const LocalityTrendsPage: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetch(`${API_BASE}/locality-trends/slug/${slug}`)
            .then(res => res.json())
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [slug]);

    if (loading) return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center gap-4">
            <div className="w-12 h-12 border-4 border-blue-600/20 border-t-blue-600 rounded-full animate-spin"></div>
            <p className="text-slate-500 font-bold text-sm tracking-widest uppercase">Analyzing Market Dynamics...</p>
        </div>
    );
    
    if (!data?.locality) return (
        <div className="min-h-screen bg-white flex items-center justify-center font-bold text-slate-400">Locality Data Not Available</div>
    );

    return (
        <div className="bg-white min-h-screen font-sans">
            <Navbar transparent={false} />

            {/* Section 1: Title, Stats & Chart */}
            <PriceTrendsHeader 
                locality={data.locality} 
                projects={data.projects || []} 
            />

            {/* Section 2: Property Supply */}
            <PropertySupply 
                localityName={data.locality.name} 
                projects={data.projects || []} 
            />

            {/* Section 3: Property Demand */}
            <PropertyDemand 
                localityName={data.locality.name} 
                projects={data.projects || []} 
            />

            {/* Section 4: Projects in Locality */}
            <LocalProjects 
                localityName={data.locality.name} 
                projects={data.projects || []} 
            />

            <Footer />
        </div>
    );
};

export default LocalityTrendsPage;
